module.exports = __webpack_public_path__ + "img/placeholder1.7cfaced3.jpg";